export default __webpack_public_path__ + "static/media/bd_profil.6c0f1b21.jpg";